import { c as _c } from "react/compiler-runtime";
import CopilotTableCard from 'shared/copilot/components/CopilotTableCard';
import { type CopilotTableData } from 'shared/copilot/tables/types';
import { type ReactElement } from 'react';
interface MarkdownCopilotTableProps {
  'data-id'?: string;
  tableIdMap?: Map<string, unknown>;
  variant?: 'compact' | 'standard';
}
const isCopilotTableData = (value: unknown): value is CopilotTableData => typeof value === 'object' && value != null && 'headers' in value && 'rows' in value;
export const MarkdownCopilotTable = t0 => {
  const $ = _c(7);
  const {
    "data-id": id,
    tableIdMap,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "compact" : t1;
  if (id == null || tableIdMap == null) {
    return null;
  }
  let t2;
  let table;
  if ($[0] !== id || $[1] !== tableIdMap) {
    table = tableIdMap.get(id);
    t2 = isCopilotTableData(table);
    $[0] = id;
    $[1] = tableIdMap;
    $[2] = t2;
    $[3] = table;
  } else {
    t2 = $[2];
    table = $[3];
  }
  if (!t2) {
    return null;
  }
  let t3;
  if ($[4] !== table || $[5] !== variant) {
    t3 = <CopilotTableCard table={table} variant={variant} />;
    $[4] = table;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};